// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static_fe/css/" + chunkId + "." + "3d04efaa" + ".chunk.css";
};